import * as React from 'react';
import { Link } from 'react-router-dom';

export interface PublicHeaderProps {
  title?: string;
  subtitle?: string;
}

export const PublicHeader = (props: PublicHeaderProps) => (
  <header className="tc">
    <Link to="/" className="db pt4 tc link black">
      <img className="br4 h3 w3 dib" src="/images/filtru.png" alt="App Icon" />
      <h1 className="f5 tracked-mega ma0 mt2 ttu">Filtru Coffee</h1>
    </Link>
    {props.title && (
      <h1 className="tc f1-ns lh-title b ma0 mt5">{props.title}</h1>
    )}
    {props.subtitle && (
      <p className="f5 f4-ns lh-copy black-70 ma0 mb4">{props.subtitle}</p>
    )}
  </header>
);

export default PublicHeader;
